// import { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { setDeferredPrompt } from "../store/pwaSlice";

// const usePwa = () => {
//   const dispatch = useDispatch();
//   const [showInstallButton, setShowInstallButton] = useState(true);
//   const deferredPrompt = useSelector((state) => state.pwa?.deferredPrompt);

//   useEffect(() => {
//     pwaConected();
//     if(checkPWA())
//       setShowInstallButton(false)
//   }, []);

//   const pwaConected = () => {
//     const handleBeforeInstallPrompt = (event) => {
//       dispatch(setDeferredPrompt(event));
//       event.preventDefault();
//       // Show your custom install button
//       if (event) {
//         setShowInstallButton(true);
//         return event;
//       }
//     };

//     window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

//     // Check if the app is already installed
//     window.addEventListener("appinstalled", () => {
//       // App is already installed, hide the install button
//       setShowInstallButton(false);
//     });
//     return;
//   };

//   const installApp = () => {
//     if (deferredPrompt) {
//       deferredPrompt.prompt();
//       deferredPrompt.userChoice.then((choiceResult) => {
//         if (choiceResult.outcome === "accepted") {
//           console.log("User accepted the A2HS prompt");
//         } else {
//           console.error("User dismissed the A2HS prompt");
//         }
//       });
//     }
//   };

//   const checkPWA = () => {
//     let value = false
//     if(window?.matchMedia('(display-mode: standalone)')?.matches || window?.navigator?.standalone)
//       value = true
//     return value
//   }

//   return {
//     installApp,
//     checkPWA,
//     showInstallButton,
//   };
// };

// export default usePwa;


import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDeferredPrompt } from "../store/pwaSlice";

const usePwa = () => {
  const dispatch = useDispatch();
  const deferredPrompt = useSelector((state) => state.pwa?.deferredPrompt);

  const [showInstallButton, setShowInstallButton] = useState(false);

  const checkPWA = () => {
    return (
      window?.matchMedia?.("(display-mode: standalone)")?.matches ||
      window?.navigator?.standalone
    );
  };

  useEffect(() => {
    // אם כבר מותקן - לא מציגים
    if (checkPWA()) setShowInstallButton(false);

    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault(); // חייב להיות ראשון
      dispatch(setDeferredPrompt(event));
      setShowInstallButton(true);
    };

    const handleAppInstalled = () => {
      setShowInstallButton(false);
      dispatch(setDeferredPrompt(null));
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, [dispatch]);

  const installApp = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const choiceResult = await deferredPrompt.userChoice;

    // accepted / dismissed
    if (choiceResult.outcome === "accepted") {
      setShowInstallButton(false);
    }

    // one-shot
    dispatch(setDeferredPrompt(null));
  };

  return {
    installApp,
    checkPWA,
    showInstallButton,
    deferredPrompt, // לפעמים נוח ל-UI
  };
};

export default usePwa;